import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IMsfFormBuilder} from '@components/form-builder/form-builder';
import {DynamicDataTableComponent} from '@components/dynamic-data-table/dynamic-data-table.component';
import {Filters} from '@components/views/filters/filters';
import {TableColumn} from '@components/data-table/data-table.component';
import {BackButton} from '@components/ui/back-button/back-button';
import {ListPageWrapper} from '@app/wrappers/pages/list-page-wrapper/list-page-wrapper';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SortType} from '@6grain/masofa-monolith-api-client/crop-monitoring/model/sortType';
import {RequestParams} from '@components/select/resource-component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-list-table-filters-wrapper',
  templateUrl: './list-table-filters-wrapper.html',
  styleUrl: './list-table-filters-wrapper.scss',
  standalone: true,
  imports: [
    DynamicDataTableComponent,
    Filters,
    BackButton,
    ListPageWrapper,
    CommonModule,
    FormsModule,
    TranslateModule,
  ],
})
export class ListTableFiltersWrapper {
  @Input({required: true}) filtersForms: IMsfFormBuilder[] = [];
  @Input({required: true}) filterModel: any = {};
  @Input({required: true}) toggleFilter: boolean | undefined = undefined;
  @Input({required: true}) isLoading: boolean = false;
  @Input({required: true}) storageKey: any = '';
  @Input({required: true}) service: any;
  @Input({required: true}) getAllMethod: string = '';
  @Input({required: true}) columns: TableColumn[] = [];

  @Input() getTotalMethod: string | undefined = undefined;
  @Input({required: true}) filtersParams: Object[] = [];
  @Input({required: true}) title!: string;
  @Input() subtitle!: string;
  @Input() parentRoute!: string;
  @Input() methodWithParams = true;
  @Input() backButton = true;
  @Input() filterBackground = true;
  @Input() showFilter = true;

  @Input() defaultParams: RequestParams = {
    take: 10,
    offset: 0,
    sort: SortType.NUMBER_1,
    filters: [],
  };

  @Output() applyFilters = new EventEmitter();
  @Output() filterModelChange = new EventEmitter();
  @Output() clearFilters = new EventEmitter();
  @Output() onRowClick = new EventEmitter();
  @Output() onFilterSaved = new EventEmitter();
  @Output()  currentPageData: any = new EventEmitter();

  filterSaved($event: any) {
    if (this.storageKey) {
      this.filterModel = $event;
    }
    setTimeout(() => {
      this.onFilterSaved.emit($event);
    }, 100);
  }


}
